export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Experience Comfort &amp; Hospitality
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              Serene Guest House offers a tranquil escape in Islamkot, where traditional hospitality meets modern comfort. Our guest house is designed to provide you with a peaceful and memorable stay, whether you're visiting for business or leisure.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              Located in the heart of Islamkot, we pride ourselves on offering clean, comfortable accommodations with personalized service. Our dedicated staff ensures that every guest feels at home from the moment they arrive.
            </p>
            <div className="grid grid-cols-3 gap-6 mt-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-hotel-bed-line text-emerald-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-semibold text-gray-900 text-sm">Comfortable Rooms</h3>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-customer-service-2-line text-emerald-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-semibold text-gray-900 text-sm">24 HOUR Service</h3>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-map-pin-line text-emerald-600 text-2xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <h3 className="font-semibold text-gray-900 text-sm">Prime Location</h3>
              </div>
            </div>
          </div>
          <div className="relative h-96 md:h-full">
            <img
              src="https://static.readdy.ai/image/371a11a079090e3c8753f93621c6a170/b435b75c8d8f77918c839948dfbe922a.jpeg"
              alt="Guest House Interior"
              className="w-full h-full object-cover rounded-lg shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
